module.exports = __webpack_public_path__ + "img/icon-72x72.287da1a2.png";